import React from "react";

const Signup = () => {
  return <h2>This is Signup</h2>;
};

export default Signup;
